export const accountHoldersEn = {};

export const accountHoldersFr = {};
